import { ThemeColors } from '~/themes/colors'

export interface MangoAlertColors {
  Background: {
    Loading: ThemeColors
    Success: ThemeColors
    Error: ThemeColors
    Warning: ThemeColors
    Info: ThemeColors
  }
  BoxShadow: ThemeColors
  FontColor: ThemeColors
  Icon: ThemeColors
  CircularProgress: {
    TrackColor: ThemeColors
    ProgressColor: ThemeColors
  }
}

export const mangoAlertColors: MangoAlertColors = {
  Background: {
    Loading: {
      default: 'blue.700',
    },
    Success: {
      default: 'green.700',
    },
    Error: {
      default: 'red.800',
    },
    Warning: {
      default: 'red.800',
    },
    Info: {
      default: 'blue.700',
    },
  },
  BoxShadow: {
    default: 'mask.gray.1300.20',
  },
  FontColor: {
    default: 'white',
  },
  Icon: {
    default: 'white',
  },
  CircularProgress: {
    TrackColor: {
      default: 'gray.500',
    },
    ProgressColor: {
      default: 'white',
    },
  },
}
